import { lazy } from 'react';
const SingleDelivery = lazy(() => import('../pages/admin/delivery/SingleDelivery'));
const CreateInsurance = lazy(() => import('../pages/admin/insurancecompany/Create'));
const ProfileVerification = lazy(() => import('../pages/admin/verification/Profile'));
const InsuranceList = lazy(() => import('../pages/admin/insurancecompany/Index'));
const InsuranceEdit = lazy(() => import('../pages/admin/insurancecompany/Edit'));
const ProductList = lazy(() => import('../pages/admin/product/ProductList'));
const PlanList = lazy(() => import('../pages/admin/subscription/PlanList'));
const CreateType = lazy(() => import('../pages/admin/insurance/CreateType'));
const UserWithdrawal = lazy(() => import('../pages/admin/users/Withdrawal'));
const UserProfile = lazy(() => import('../pages/admin/users/UserProfile'));
const CreatePartner = lazy(() => import('../pages/admin/partner/Create'));
const ViewWithdrawl = lazy(() => import('../pages/admin/withdrawl/View'));
const ViewInsurance = lazy(() => import('../pages/admin/insurance/View'));
const CreateAdmin = lazy(() => import('../pages/admin/subadmin/Create'));
const SingleRide = lazy(() => import('../pages/admin/rides/SingleRide'));
const CreateService = lazy(() => import('../pages/admin/services/Create'));
const Profiles = lazy(() => import('../pages/admin/verification/Index'));
const CreateCoupon = lazy(() => import('../pages/admin/coupons/Create'));
const Create = lazy(() => import('../pages/admin/subscription/Create'));
const Delivery = lazy(() => import('../pages/admin/delivery/Delivery'));
const EditService = lazy(() => import('../pages/admin/services/Edit'));
const RidePrice = lazy(() => import('../pages/admin/rides/RidePrice'));
const PartnerList = lazy(() => import('../pages/admin/partner/Index'));
const ViewPartner = lazy(() => import('../pages/admin/partner/View'));
const PartnerEdit = lazy(() => import('../pages/admin/partner/Edit'));
const AdminList = lazy(() => import('../pages/admin/subadmin/Index'));
const AdminEdit = lazy(() => import('../pages/admin/subadmin/Edit'));
const Withdrawl = lazy(() => import('../pages/admin/withdrawl/Index'));
const Insurance = lazy(() => import('../pages/admin/insurance/Index'));
const VTypes = lazy(() => import('../pages/admin/vechiletypes/Index'));
const ETypes = lazy(() => import('../pages/admin/vechiletypes/Edit'));
const VeType = lazy(() => import('../pages/admin/vechiletypes/View'));
const CTypes = lazy(() => import('../pages/admin/vechiletypes/Create'));
const RoleCreate = lazy(() => import('../pages/admin/roles/Create'));
const EditCoupon = lazy(() => import('../pages/admin/coupons/Edit'));
const TopRanking = lazy(() => import('../pages/admin/ranking/Index'));
const Services = lazy(() => import('../pages/admin/services/Index'));
const PaymentInfo = lazy(() => import('../pages/admin/PaymentInfo'));
const Edit = lazy(() => import('../pages/admin/subscription/Edit'));
const Earning = lazy(() => import('../pages/admin/earning/Index'));
const RoleIndex = lazy(() => import('../pages/admin/roles/Index'));
const Charges = lazy(() => import('../pages/admin/charges/Index'));
const Coupon = lazy(() => import('../pages/admin/coupons/Index'));
const RoleEdit = lazy(() => import('../pages/admin/roles/Edit'));
const UserEdit = lazy(() => import('../pages/admin/users/Edit'));
const Dashboard = lazy(() => import('../pages/admin/Dashboard'));
const Emails = lazy(() => import('../pages/admin/emails/Index'));
const Trips = lazy(() => import('../pages/admin/trips/Trips'));
const Trip = lazy(() => import('../pages/admin/trips/Trip'));
const User = lazy(() => import('../pages/admin/users/User'));
const Ride = lazy(() => import('../pages/admin/rides/Ride'));
const Profile = lazy(() => import('../pages/admin/Profile'));
const Add = lazy(() => import('../pages/admin/charges/Add'));
const Payment = lazy(() => import('../pages/admin/Payment'));
const Slider = lazy(() => import('../pages/admin/Slider'));

const AdminRoute = [
    { path: '/admin/slider', name: 'Slider', component: <Slider /> },
    { path: '/admin/payment/history/:page?', name: 'Payment', component: <Payment /> },
    { path: '/admin/payment/history/info/:type/:id', name: 'info', component: <PaymentInfo /> },
    { path: '/admin/slider/:id?', name: 'Slider', component: <Slider /> },
    { path: '/admin/charges', name: 'Charges', component: <Charges /> },
    { path: '/admin/dashboard', name: 'Dashboard', component: <Dashboard /> },
    { path: '/admin/profile', name: 'Profile', component: <Profile /> },
    { path: '/admin/ride/list/:type?/:page?', name: 'Ride', component: <Ride /> },
    { path: '/admin/users/list/:type?/:page?', name: 'User', component: <User /> },
    { path: '/admin/user/withdrawals/:user/:page?', name: 'UserWithdrawal', component: <UserWithdrawal /> },
    { path: '/admin/:type/edit/:id', name: 'User', component: <UserEdit /> },
    { path: '/admin/ride/:type/:id', name: 'SingleRide', component: <SingleRide /> },
    // { path: '/admin/ride/:id', name: 'SingleRide', component: <SingleRide /> },
    { path: '/admin/products', name: 'ProductList', component: <ProductList /> },
    { path: '/admin/delivery/list/:page?', name: 'Delive', component: <Delivery /> },
    { path: '/admin/:type/profile/:id', name: 'Profile', component: <UserProfile /> },
    { path: '/admin/delivery/:id', name: 'SDelivery', component: <SingleDelivery /> },
    { path: '/admin/ride-price', name: 'RidePrice', component: <RidePrice /> },
    { path: '/admin/subscription-plans', name: 'PlanList', component: <PlanList /> },
    { path: '/admin/create-plan', name: 'Create', component: <Create /> },
    { path: '/admin/edit-plan/:id', name: 'Edit', component: <Edit /> },
    { path: '/admin/admin-list/:page?', name: 'Admins', component: <AdminList /> },
    { path: '/admin/admin-create', name: 'CreateAdmin', component: <CreateAdmin /> },
    { path: '/admin/edit/:id', name: 'AdminEdit', component: <AdminEdit /> },
    { path: '/admin/partner-create', name: 'CPart', component: <CreatePartner /> },
    { path: '/admin/partner/edit/:id', name: 'CPart', component: <PartnerEdit /> },
    { path: '/admin/partner/view/:id', name: 'ViewPartner', component: <ViewPartner /> },
    { path: '/admin/partner-list/:page?', name: 'Partners', component: <PartnerList /> },
    { path: '/admin/insurance-list/:page?', name: 'Insurance', component: <InsuranceList /> },
    { path: '/admin/insurance-create', name: 'Insurance', component: <CreateInsurance /> },
    { path: '/admin/earnings/:type/:page?', name: 'Earning', component: <Earning /> },
    { path: '/admin/withdrawl/:type/:page?', name: 'Withdrawl', component: <Withdrawl /> },
    { path: '/admin/withdrawl/view/:id', name: 'ViewWithdrawl', component: <ViewWithdrawl /> },
    { path: '/admin/insurance/:type?/:page?', name: 'Insurance', component: <Insurance /> },
    { path: '/admin/insurance/edit/:id', name: 'InsuranceEdit', component: <InsuranceEdit /> },
    { path: '/admin/insurance/view/:id', name: 'ViewInsurance', component: <ViewInsurance /> },
    { path: '/admin/create/insurance-type', name: 'CreateType', component: <CreateType /> },
    { path: '/admin/roles', name: 'RoleIndex', component: <RoleIndex /> },
    { path: '/admin/role/create', name: 'RoleCreate', component: <RoleCreate /> },
    { path: '/admin/role/edit/:id', name: 'RoleEdit', component: <RoleEdit /> },
    { path: '/admin/driver/trips/:page?', name: 'Trips', component: <Trips /> },
    { path: '/admin/driver/trip/:id', name: 'Trip', component: <Trip /> },
    { path: '/admin/profile/verifications/:type/:page?', name: 'Profiles', component: <Profiles /> },
    { path: '/admin/profile/verification/view/:id', name: 'Profiles', component: <ProfileVerification /> },
    { path: '/admin/top/ranking/:type', name: 'TopRanking', component: <TopRanking /> },
    { path: '/admin/emails/:type?/:page?', name: 'Emails', component: <Emails /> },
    { path: '/admin/coupons/:page?', name: 'Coupon', component: <Coupon /> },
    { path: '/admin/create/coupon', name: 'Couponc', component: <CreateCoupon /> },
    { path: '/admin/edit/coupon/:id', name: 'Couponc', component: <EditCoupon /> },
    { path: '/admin/services/:page?', name: 'Services', component: <Services /> },
    { path: '/admin/service/create', name: 'CreateService', component: <CreateService /> },
    { path: '/admin/services/edit/:id', name: 'EditService', component: <EditService /> },
    { path: '/admin/vechile-types/:page?', name: 'VTypes', component: <VTypes /> },
    { path: '/admin/vechile-types/create', name: 'CTypes', component: <CTypes /> },
    { path: '/admin/vechile-types/edit/:id', name: 'ETypes', component: <ETypes /> },
    { path: '/admin/vechile-types/view/:id', name: 'VeType', component: <VeType /> },
    { path: '/admin/driver-charges', name: 'Add', component: <Add /> },
];

export default AdminRoute;